module.exports = __webpack_public_path__ + "static/media/video-exercisetmchange-tms.7cd66b50.mp4";